import {
  Delegation,
  IDelegation,
  IUserClientSubclient,
  IUserClientSubclientData,
  IUserClientSubclientServicepoint,
  UserClientSubclientServicepoint,
} from "@/entities";

export class UserClientSubclient implements IUserClientSubclient {
  readonly id?: number;
  readonly oidSol?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: string;
  readonly uniqueCode?: string;
  readonly description?: string;
  readonly active?: boolean;
  readonly delegation?: IDelegation;
  readonly servicepoints?: IUserClientSubclientServicepoint[];

  constructor(data: IUserClientSubclientData) {
    this.id = data.id;
    this.oidSol = data.oidSol;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.uniqueCode = data.uniqueCode;
    this.description = data.description;
    this.active = data.active;

    if (data.delegation) {
      this.delegation = new Delegation(data.delegation);
    }

    this.servicepoints = data.servicepoints?.map(
      (servicepoint) => new UserClientSubclientServicepoint(servicepoint)
    );
  }
}
